import { useMemo } from 'react';

import { Flex } from '@chakra-ui/react';

import { RatingRateProps } from './rating-rate.props';

export const RatingRate = ({ ratingAverage, size = 'md', ...props }: RatingRateProps) => {
    const sizes = useMemo(() => {
        switch (size) {
            case 'lg':
                return {
                    box: {
                        base: 14,
                        md: 16,
                    },
                    rate: {
                        base: 'lg',
                        md: '2xl',
                    },
                };
            case 'sm':
                return {
                    box: 8,
                    rate: 'sm',
                };
            case 'accommodationTile':
                return {
                    w: {
                        base: '26px',
                        md: 8,
                    },
                    h: {
                        base: 5,
                        md: 8,
                    },
                    rate: {
                        base: 'xs',
                        md: 'md',
                    },
                };
            default:
                return {
                    box: {
                        base: 11,
                        md: 12,
                    },
                    rate: 'lg',
                };
        }
    }, [size]);

    return (
        <Flex
            backgroundColor={'secondary.solid'}
            color={'white'}
            justify={'center'}
            flex={'0 0 auto'}
            w={sizes.box ?? sizes.w}
            h={sizes.box ?? sizes.h}
            fontSize={sizes.rate}
            alignItems={'center'}
            fontWeight={'bold'}
            borderRadius={4}
            lineHeight={1}
            data-testid="rating-average"
            as={'span'}
            {...props}
        >
            {ratingAverage < 10 ? ratingAverage.toFixed(1) : ratingAverage}
        </Flex>
    );
};
